module.exports = __webpack_public_path__ + "static/media/website-sogal.3e689b82.png";